import * as React from 'react';
import { recipes } from './Dataset';
import { IMaterial, IRecipe } from './Interfaces';
import Recipe from './Recipe';
import { Link } from './Link';

export interface IMaterialProps {
  item: IMaterial;
}

function materialSort(a: IRecipe, b: IRecipe) {
  const na = Object.keys(a.input).length;
  const nb = Object.keys(b.input).length;
  return (
    na > nb ? 1 :
      nb > na ? -1 :
        a.name > b.name ? 1 : -1
  );
}

export class Material extends React.Component<IMaterialProps> {
  constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {
    const { item } = this.props;
    const refining = item.recipes.filter(r => !r.input[item.id]);
    const multipliers = item.recipes.filter(r => !!r.input[item.id]);

    return (
      <div className="material">
        <h1>{item.name}</h1>
        {!!refining.length && (
          <React.Fragment>
            <h2>Refining:</h2>
            <ul>
              {refining
                .sort(materialSort)
                .map((recipe, ix) => (<Recipe key={ix} material={item} recipe={recipe} />))}
            </ul>
          </React.Fragment>
        )}
        {!!multipliers.length && (
          <React.Fragment>
            <h2>Multipliers:</h2>
            <ul>
              {multipliers
                .sort(materialSort)
                .map((recipe, ix) => (<Recipe key={ix} material={item} recipe={recipe} />))}
            </ul>
          </React.Fragment>
        )}
        {!!item.uses.length && (
          <React.Fragment>
            <h2>Used in:</h2>
            <ul className="uses">
              {item.uses.filter(key => key !== item.id).map((key) => (
                <li key={key}><Link icon={key} label={recipes[key].name} location={`#${key}`} /></li>
              ))}
            </ul>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Material;



// WEBPACK FOOTER //
// ./src/Material.tsx